import { useState } from "react";
import Card from "../Card";
import Text from "../Text";
import { getImg } from "../../../../Components/Utils";
import { Eye, MessageCircle } from "lucide-react";
import QuickViewModal from "../QuickViewModal";
import { ROUTE_PATHS } from "../../../../constants/routeConstants";
const iconBtn =
  "h-9 w-9 rounded-full border border-gray-200 bg-white/95 text-gray-700 backdrop-blur flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#2563eb] hover:text-white";

const toSlug = (title) =>
  (title ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const ProductCard = ({
  product,
  withoutBody = false,
  withoutActions = false,
}) => {
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || null;

  const [modal, setModal] = useState(false);

  const title = product.name ?? product.title ?? "";
  const img = getImg(product.image ?? product.img);
  const hoverImg = getImg(product.images?.[0]?.image ?? product.hoverImg ?? product.img);

  const badge = product.badge ?? (
    product.createdAt && (Date.now() - new Date(product.createdAt).getTime()) < 30 * 24 * 60 * 60 * 1000
      ? "New"
      : undefined
  );
  const fullProduct = { ...product, title, image: img, hoverImg };
  const productHref = product.slug
    ? ROUTE_PATHS.PRODUCT_SINGLE.replace(":productSlug", product.slug)
    : ROUTE_PATHS.PRODUCT_SINGLE.replace(":productSlug", toSlug(title));
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`Hi! I'm interested in: *${title}*`)}`;

  return (
    <>
      <Card
        bg={fullProduct.img || fullProduct.hoverImg}
        hoverImg={fullProduct.hoverImg || fullProduct.img}
        badge={badge}
        category={product.categories?.name ?? product.category ?? undefined}
        href={productHref}
      >
        {!withoutBody ? (
          <div className="flex flex-1 flex-col gap-3 bg-white p-4">
            <div>
              <Text
                is="a"
                href={productHref}
                variant="body"
                className="mb-1 block line-clamp-2 text-sm font-semibold leading-5 text-gray-950 transition-colors hover:text-blue-600"
              >
                {title}
              </Text>
              {product.description && (
                <Text
                  is="p"
                  variant="body"
                  className="line-clamp-2 text-xs leading-4 text-gray-500"
                >
                  {product.description}
                </Text>
              )}
            </div>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="mt-auto inline-flex h-10 w-full items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#1ebe5d]"
            >
              <MessageCircle size={16} />
              Ask on WhatsApp
            </a>
          </div>
        ) : null}

        {!withoutActions && (
          <>
            <button
              className={iconBtn}
              aria-label="Quick view"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setModal(true);
              }}
            >
              <Eye size={15} />
            </button>
            <button
              type="button"
              className={iconBtn}
              aria-label="WhatsApp"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                window.open(whatsappUrl, "_blank", "noopener,noreferrer");
              }}
            >
              <MessageCircle size={16} />
            </button>
          </>
        )}
      </Card>

      {modal && (
        <QuickViewModal product={fullProduct} onClose={() => setModal(false)} />
      )}
    </>
  );
};

export default ProductCard;
